import { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import configs from "./configs";
import colors from "assets/theme/base/colors";
import { useMaterialUIController } from "context";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function HorizontalBarChart({
  icon,
  title,
  description,
  height,
  locationsRevenue,
}) {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  // Compute top 5 only once based on revenue
  const top5 = useMemo(() => {
    if (!locationsRevenue?.length) return [];
    return [...locationsRevenue]
      .sort((a, b) => b.totalRevenue - a.totalRevenue)
      .slice(0, 5);
  }, [locationsRevenue]);

  // Create datasets only when top5 changes
  const { data, options } = useMemo(() => {
    const labels = top5.map((item) => item.parkingCode);
    const rawData = top5.map((item) => item.totalRevenue);

    const datasetConfig = [
      {
        label: "Total Revenue",
        weight: 5,
        borderWidth: 0,
        borderRadius: 4,
        backgroundColor: colors[sidenavColor].main,
        data: rawData,
        maxBarThickness: 20,
      },
    ];

    return configs(labels, datasetConfig);
  }, [top5, sidenavColor]);

  return (
    <Card>
      <MDBox py={2} pr={2} pl={icon.component ? 1 : 2}>
        {(title || description) && (
          <MDBox
            display="flex"
            px={description ? 1 : 0}
            pt={description ? 1 : 0}
          >
            {icon.component && (
              <MDBox
                width="4rem"
                height="4rem"
                bgColor={sidenavColor}
                variant="gradient"
                coloredShadow={sidenavColor}
                borderRadius="xl"
                display="flex"
                justifyContent="center"
                alignItems="center"
                color="white"
                mt={-5}
                mr={2}
              >
                <Icon fontSize="medium">{icon.component}</Icon>
              </MDBox>
            )}

            <MDBox mt={icon.component ? -2 : 0}>
              <MDTypography variant="h6">{title}</MDTypography>
              <MDBox mb={2}>
                <MDTypography component="div" variant="button" color="text">
                  {description}
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
        )}

        <MDBox height={height}>
          <Bar data={data} options={options} />
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default HorizontalBarChart;
